import { PartnerRegisters } from 'shared/components/partner-registers/PartnerRegisters'

/**
 * «Реестры» at the central cashbox (ADR-0036, ticket 16): the cashier builds the
 * partner's Register for a period that has ended and marks it paid with the payment
 * order number; the admin sees the same.
 */
export function RegistersTab() {
	return <PartnerRegisters canWork />
}
